import React, { useState } from 'react';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import classnames from "classnames";

const PhoneInputWithCountry = ({ 
  value, 
  onChange, 
  onFocus, 
  onBlur, 
  placeholder,
  className 
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({
    code: '+233',
    flag: '🇬🇭',
    name: 'Ghana'
  });

  const countries = [
    { code: '+233', flag: '🇬🇭', name: 'Ghana' },
    { code: '+234', flag: '🇳🇬', name: 'Nigeria' },
    { code: '+225', flag: '🇨🇮', name: 'Ivory Coast' },
    { code: '+228', flag: '🇹🇬', name: 'Togo' },
    { code: '+226', flag: '🇧🇫', name: 'Burkina Faso' },
    { code: '+255', flag: '🇹🇿', name: 'Tanzania' },
    { code: '+27', flag: '🇿🇦', name: 'South Africa' },
    { code: '+251', flag: '🇪🇹', name: 'Ethiopia' },
    { code: '+256', flag: '🇺🇬', name: 'Uganda' },
    { code: '+237', flag: '🇨🇲', name: 'Cameroon' },
  ];

  const handlePhoneChange = (e) => {
    // Remove any non-digit characters except the country code
    const cleanedValue = e.target.value.replace(/[^\d+]/g, '');
    onChange({
      target: {
        name: 'user_phone',
        value: cleanedValue
      }
    });
  };

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const selectCountry = (country) => {
    setSelectedCountry(country);
    setDropdownOpen(false);
  };

  return (
    <InputGroup className={`input-group-merge input-group-alternative mb-2 ${className}`}>
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <i className="ni ni-mobile-button" />
        </InputGroupText>
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle className="btn-sm" color="secondary" caret>
            <span className="mr-1">{selectedCountry.flag}</span>
            <span>{selectedCountry.code}</span>
          </DropdownToggle>
          <DropdownMenu>
            {countries.map((country) => (
              <DropdownItem 
                key={country.code} 
                onClick={() => selectCountry(country)}
              >
                <span className="mr-2">{country.flag}</span>
                <span className="mr-2">{country.code}</span>
                <span>{country.name}</span>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </InputGroupAddon>
      <Input
        placeholder={placeholder}
        type="tel"
        value={value}
        onChange={handlePhoneChange}
        onFocus={onFocus}
        onBlur={onBlur}
        maxLength={15}
      />
    </InputGroup>
  );
};

export default PhoneInputWithCountry;